/**
 * Breadcrumb đặt `zoom: 93%` cho body ở các trang nhập / xuất kho. Chromium bản mới (zoom chuẩn hoá, từ bản 128)
 * trả toạ độ getBoundingClientRect đã nhân zoom, còn lớp xổ xuống của Mantine (floating-ui) đặt top / left bên trong
 * body đã zoom nên bị nhân thêm lần nữa: lớp xổ xuống lệch lên trên 7% toạ độ, ô càng thấp càng lệch, che cả ô nhập.
 *
 * Lớp xổ xuống của trang render vào một khung riêng có zoom nghịch đảo (1 / zoom của body), để zoom thực bằng 1 và
 * toạ độ khớp. Trình duyệt cũ (zoom kiểu cũ, toạ độ chưa nhân zoom) thì khung giữ zoom 1 như bình thường.
 */

let root: HTMLDivElement | null = null;
let observer: MutationObserver | null = null;

const readBodyZoom = () => {
  const zoom = parseFloat(getComputedStyle(document.body).getPropertyValue("zoom"));
  return zoom > 0 ? zoom : 1;
};

/** Trình duyệt có nhân zoom vào getBoundingClientRect không (zoom chuẩn hoá) */
const rectIncludesZoom = (zoom: number) => {
  if (zoom === 1) return false;
  const probe = document.createElement("div");
  probe.style.cssText = "position:absolute;visibility:hidden;width:100px;height:1px;left:0;top:0";
  document.body.appendChild(probe);
  const width = probe.getBoundingClientRect().width;
  probe.remove();
  return Math.abs(width - 100 * zoom) < 1;
};

const syncZoom = () => {
  if (!root) return;
  const zoom = readBodyZoom();
  // TS 4.9 chưa có `zoom` trong CSSStyleDeclaration
  root.style.setProperty("zoom", rectIncludesZoom(zoom) ? String(1 / zoom) : "1");
};

/** Khung chứa lớp xổ xuống (portalProps.target) đã bù zoom của body */
export const getZoomSafePortalTarget = (): HTMLElement => {
  if (!root || !root.isConnected) {
    root = document.createElement("div");
    root.setAttribute("data-return-inward-portal", "");
    document.body.appendChild(root);
    observer?.disconnect();
    // Breadcrumb đổi zoom theo đường dẫn: tính lại khi thuộc tính style của body đổi
    observer = new MutationObserver(syncZoom);
    observer.observe(document.body, { attributes: true, attributeFilter: ["style"] });
  }
  syncZoom();
  return root;
};
